var _defs, _path, _path2, _path3, _path4, _path5, _polygon, _path6, _path7, _path8, _path9, _path0, _path1, _polygon2, _path10, _polygon3, _path11, _polygon4, _path12, _polygon5, _path13, _polygon6, _path14, _polygon7, _path15, _polygon8, _path16, _polygon9, _path17, _polygon0, _path18, _polygon1, _path19, _polygon10, _path20, _polygon11, _path21, _polygon12, _path22, _polygon13, _path23, _polygon14, _path24, _polygon15, _path25, _polygon16, _path26, _polygon17, _path27, _polygon18, _path28, _polygon19, _path29, _polygon20, _path30, _polygon21, _path31, _polygon22, _path32, _polygon23, _path33, _polygon24, _path34, _polygon25, _path35, _polygon26, _path36, _polygon27, _path37, _polygon28, _path38, _polygon29, _path39, _path40, _path41;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNovitaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 594.94 210.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#dbb7bb;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NOVITA-LOGO") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.07,328.63,62.92,204h9.94L164,318.11V204h8.77V328.63Zm-98.76,0V215.27l8.77,11.1V328.63Z",
    transform: "translate(-60.77 -198.67)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.18,328.63,312.64,204h9.54l54.15,124.66Zm12.66-8-4.29-10.32L422.1,204h9.74Z",
    transform: "translate(-60.77 -198.67)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M601,204l54.54,124.66H646L591.82,204Zm-12.66,8,4.28,10.32L546.05,328.63h-9.74Z",
    transform: "translate(-60.77 -198.67)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.77,406.9V350.18H72c5,0,13.78.76,20.92,7.91,6,6,8.16,14.28,8.16,20.49A29.33,29.33,0,0,1,92.92,399C85.78,406.13,77,406.9,72,406.9Zm3.75-3.4h7.4c15,0,25.25-10.21,25.25-24.92,0-14.54-10.37-25-25.25-25h-7.4Z",
    transform: "translate(-60.77 -198.67)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.58,350.18V406.9h-3.74V350.18Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "140.06 149.8 116.17 208.23 120.25 208.23 127.81 189.6 129.18 186.2 139.98 159.33 150.6 186.2 151.97 189.6 159.53 208.23 163.62 208.23 140.06 149.8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.15,406.9l6.47-58.68,24.57,52.47,24.58-52.47,6.46,58.68h-3.74l-5-45.58s-22.19,47.62-22.28,47.62l-22.28-47.62-5,45.58Z",
    transform: "translate(-60.77 -198.67)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M416.24,378.67a29,29,0,0,1-29.42,29.16c-16.67,0-29.42-12.84-29.42-29.16a29.42,29.42,0,0,1,58.84,0Zm-3.91,0c0-14.55-10.88-25.86-25.51-25.86s-25.51,11.31-25.51,25.86,10.88,25.76,25.51,25.76S412.33,393.12,412.33,378.67Z",
    transform: "translate(-60.77 -198.67)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M454,406.9V349.58l47.62,49.83V350.18h3.75v58.16l-47.63-49.83V406.9Z",
    transform: "translate(-60.77 -198.67)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M546.18,406.9V350.18h11.23c5,0,13.78.76,20.92,7.91,6,6,8.16,14.28,8.16,20.49A29.33,29.33,0,0,1,578.33,399c-7.14,7.14-15.9,7.91-20.92,7.91Zm3.75-3.4h7.39c15,0,25.26-10.21,25.26-24.92,0-14.54-10.37-25-25.26-25h-7.39Z",
    transform: "translate(-60.77 -198.67)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M650.1,359.79a12.12,12.12,0,0,0-11.14-7c-6.72,0-10.54,4.85-10.54,10.55,0,6.12,4.25,8.16,10,11s8.42,3.91,11.31,5.95c2.46,1.7,6,4.68,6,11,0,9.53-8,16.58-17.69,16.58a16.17,16.17,0,0,1-13.18-5.95,18.62,18.62,0,0,1-3.66-6.21l3.23-1.53a19.8,19.8,0,0,0,3.06,5.45,13.64,13.64,0,0,0,10.63,4.84c7.66,0,13.69-5.61,13.69-13.09,0-3.06-1.19-6.3-5.52-8.93-1.62-.94-4.94-2.64-9.61-4.93-5.62-2.73-8.42-4.26-10.38-7.49a12.21,12.21,0,0,1-1.78-6.46c0-6.55,4.42-14.12,14.54-14.12a15.19,15.19,0,0,1,13.77,8.08Z",
    transform: "translate(-60.77 -198.67)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252,333.43a67.38,67.38,0,1,1,67.38-67.38A67.45,67.45,0,0,1,252,333.43ZM252,201a65.07,65.07,0,1,0,65.07,65.07A65.14,65.14,0,0,0,252,201Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "195.51 16.05 190.17 41.21 190.63 63.63 196.12 41.67 195.51 16.05"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251,266.19l-.54-26.36,6.27-29.55.72,30.12Zm.5-26.26.38,18.48,4.53-18.13-.5-21.12Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "199.28 34.14 197.86 43.1 198.43 50.98 199.96 43.15 199.28 34.14"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259,253.56l-.86-11.81,2.12-13.39,1,13.5Zm.18-11.76.29,3.95.77-4-.34-4.52Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "209.22 38.03 202.7 44.34 198.42 50.98 204.35 45.64 209.22 38.03"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256.65,252.63l6.46-10,9.71-9.38-7.35,11.44Zm7.23-9.29-2.15,3.33,3-2.69,2.44-3.83Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "217.31 46.03 210.43 51.94 205.76 58.32 212 53.34 217.31 46.03"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.83,259.82l7-9.6,10.24-8.79-8,11Zm7.76-8.85-2.34,3.2,3.15-2.52,2.67-3.67Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "222.38 55.44 213.32 56.02 205.76 58.31 213.74 58.08 222.38 55.44"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M262.67,257.61l11.4-3.44,13.46-.86-13,4Zm11.52-2.4-3.8,1.14,4-.11,4.34-1.33Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "225.15 65.25 216.16 66.43 208.76 69.2 216.7 68.46 225.15 65.25"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M265.72,268.75l11.15-4.16,13.38-1.75-12.72,4.81Zm11.34-3.14L273.35,267l4-.38L281.6,265Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "224.23 75.89 216.34 71.42 208.76 69.19 215.56 73.37 224.23 75.89"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.11,276.3l-13.05-3.81L266,266.27l11.41,3.37Zm-12.57-4.73,4.36,1.26-4-2.26-3.8-1.12Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "219.34 84.86 211.35 80.58 203.71 78.53 210.61 82.55 219.34 84.86"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.26,285.17l-13.14-3.5-10.25-6,11.49,3.11Zm-12.68-4.43L276,281.9l-4-2.16-3.83-1Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "212.4 92.98 208.59 84.75 203.72 78.52 206.81 85.87 212.4 92.98"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.5,295.45l-8.39-10.7-4.59-10.94,7.31,9.39ZM268,284.28l2.8,3.57-1.92-4.16-2.45-3.13Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "202.89 98.75 199.37 90.39 194.72 84 197.55 91.45 202.89 98.75"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M265.86,301.3l-8-11-4.21-11.08,7,9.63Zm-7.08-11.42,2.69,3.66-1.79-4.22-2.33-3.21Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "192.39 100.69 194.6 91.9 194.73 83.99 192.51 91.66 192.39 100.69"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.59,303.79l.2-13.6,3.3-11.39-.21,11.9Zm1.21-13.38-.06,4.54,1.12-4.45.06-4Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "181.99 100.65 183.87 91.78 183.71 83.88 181.78 91.62 181.99 100.65"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.35,303.77,242,290.24l2.9-11.57.24,11.84Zm.72-13.42.11,4.54.95-4.48-.08-4Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "172.26 96.25 179.1 90.3 183.73 83.89 177.52 88.91 172.26 96.25"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230,298.22l7.94-11,9.22-7.47-7,9.65Zm8.65-10.28L236,291.63l3.46-3,2.32-3.22Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "155.99 69.07 165.03 68.32 172.55 65.88 164.58 66.26 155.99 69.07"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.4,268.63l12.93-4.21,11.85-.56-11.33,3.65Zm13-3.18-4.31,1.41,4.56-.38,3.78-1.22Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "157.4 58.49 165.08 63.32 172.55 65.9 165.95 61.41 157.4 58.49"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.82,266.33l-11.24-3.9-11.43-7.19L227,259.65Zm-10.74-4.81,3.75,1.3-3.34-2.27-4.29-1.47Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "162.52 88.36 169.73 82.86 174.75 76.76 168.24 81.37 162.52 88.36"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M220.09,290.13l8.63-10.51,9.68-6.85L230.81,282Zm9.28-9.7-2.87,3.51,3.64-2.78,2.52-3.06Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "158.01 78.68 167.07 78.62 174.76 76.78 166.78 76.54 158.01 78.68"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.36,277.9l13.14-3.2h.07l11.86.34-11.58,2.78Zm13.25-2.17-4.41,1.08,4.59,0,3.85-.93Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "161.77 48.56 169.65 53.05 177.23 55.29 170.44 51.1 161.77 48.56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.58,255.56l-11.41-3.39-11.73-6.67,13.05,3.83Zm-11-4.32,3.81,1.13L231,250.25,226.65,249Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "168.91 40.63 172.52 48.95 177.22 55.3 174.32 47.87 168.91 40.63"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M239.89,257.4l-7.07-9.57-5.37-12.39,8.13,10.91Zm-6.15-10,2.36,3.19-1.46-3.75-2.72-3.64Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "178.14 34.51 181.77 42.81 186.5 49.15 183.57 41.73 178.14 34.51"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.18,251.24l-7.11-9.54-5.41-12.37,8.16,10.88Zm-6.19-10,2.38,3.18-1.48-3.76L241.16,237Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "188.61 32.42 186.51 41.25 186.48 49.15 188.61 41.46 188.61 32.42"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.73,251.7l.05-11.9,3.12-13.13,0,13.6ZM247.81,240l0,4,1.07-3.89v-4.53Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "186.06 118.69 191.23 93.5 190.62 71.08 185.28 93.08 186.06 118.69"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.45,321.81l-.92-30.11,6.28-25.84.71,26.36v0Zm.12-30,.64,21.12,4.27-20.8-.5-18.48Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "156.51 105.95 175.68 88.8 188.54 70.43 171.15 84.92 156.51 105.95"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.33,308l17.26-24.78,20.38-17-15.18,21.63Zm18-24-12.07,17.35,15.82-14.17L246.67,272Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "224.74 28.69 205.69 45.97 192.95 64.42 210.25 49.82 224.74 28.69"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.09,266l15-21.73L288.45,224l-17.09,24.89Zm15.77-21-10.51,15.2,14.29-12.05,11.95-17.42Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "165.34 22.48 175.33 46.19 188.5 64.34 180.47 43.17 165.34 22.48"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.14,266.45l-15.52-21.38-11.7-27.79,17.81,24.38Zm-14.58-21.84,10.85,15-6.62-17.48L228.31,225Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "216.19 112.16 206.05 88.52 192.75 70.46 200.92 91.57 216.19 112.16"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.18,314.7l-18-24.27-9.56-24.73L267.3,287Zm-17-24.71,12.59,17-8.37-19.52-11-14.88Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.54 46.71 165.75 59.7 187.17 66.32 168.05 54.2 143.54 46.71"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.5,266.64l-25.24-7.82-26-15.22,28.87,8.84Zm-24.77-8.74,17.66,5.46-15.78-10-20.21-6.17Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "238 88 215.71 75.16 194.24 68.67 213.44 80.67 238 88"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.87,288.43l-28.93-8.64-22.49-14.06,25.29,7.65Zm-28.44-9.56,20.25,6-18.4-10.6L258.58,269Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.16 77.37 165.8 75.36 187.17 68.56 164.56 69.52 140.16 77.37"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M196.56,276.9l28.75-9.22,26.49-1.12-25.18,8Zm28.86-8.19-20.11,6.47,21.17-1.66,17.61-5.6Z",
    transform: "translate(-60.77 -198.67)"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "241.28 57.34 215.65 59.52 194.32 66.45 216.93 65.35 241.28 57.34"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.25,265.84l25.13-8.16,30-2.56-28.69,9.42Zm25.28-7.13L259,264.42l18.66-.91,20.07-6.6Z",
    transform: "translate(-60.77 -198.67)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M447.89,328.59V203.93h9V328.59Z",
    transform: "translate(-60.77 -198.67)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M510.26,328.59V211.52H468v-7.59h50.84V328.59Zm15.19-117.07v-7.59H561.1v7.59Z",
    transform: "translate(-60.77 -198.67)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovitaLogo);
export default __webpack_public_path__ + "static/media/novita_logo.0557f0180baf2d8e488f03396a4b2b83.svg";
export { ForwardRef as ReactComponent };